export default __webpack_public_path__ + "static/media/Clearance_Specials_Web_Banner_Desktop_V5.38d415dd.jpg";